export default "__VITE_ASSET__CQBfwBNK__"